import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import GameService from '../../services/game.service';
// import { StaticGameMetaData } from '../../data/StaticData';

export const fetchGameMeta = createAsyncThunk(
  'gamesMeta/fetchGameMeta',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GameService.gameMeta();
      return response.data;
    } catch (error) {
      console.log("🚀 ~ error:", error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const gamesMetaSlice = createSlice({
  name: 'gamesMeta',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    clearGameMeta: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
    setGameMeta: (state, action) => {
      state.data = action.payload;
      state.status = 'success';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGameMeta.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchGameMeta.fulfilled, (state, action) => {
        state.status = 'success';
        state.data = action.payload;
      })
      .addCase(fetchGameMeta.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.payload || 'Failed to fetch game meta';
      });
  },
});

export const { clearGameMeta, setGameMeta } = gamesMetaSlice.actions;
export default gamesMetaSlice.reducer;
